import { tr } from "../../i18n";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Search } from "lucide-react";
import { api } from "../../auth/AuthContext";
import { Badge, EmptyState, fmtDateTime } from "../../components/portal";
export default function AdminEri() {
  const {
    lang = "en"
  } = useParams();
  const [data, setData] = useState(null);
  const [search, setSearch] = useState("");
  const [band, setBand] = useState("");
  const [page, setPage] = useState(1);
  const load = (p = page, s = search, b = band) => {
    api.get(`/admin/eri-submissions?search=${encodeURIComponent(s)}&band=${encodeURIComponent(b)}&page=${p}`).then(r => setData(r.data)).catch(() => {});
  };
  useEffect(() => {
    load(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [band]);
  const bandTone = b => b === "Established" ? "green" : b === "Developing" ? "amber" : "red";
  return <div className="mx-auto max-w-6xl" data-testid="admin-eri-page">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight text-esaia-ink">{tr("ERI Submissions")}</h1>
          <p className="mt-1 text-sm text-esaia-muted">{tr("Every completed Ethical Readiness Index, newest first.")}</p>
        </div>
        <div className="relative">
          <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-esaia-subtle" />
          <input value={search} onChange={e => setSearch(e.target.value)} onKeyDown={e => e.key === "Enter" && load(1)} placeholder={tr("Search name, company, email")} data-testid="eri-search-input" className="w-64 border border-esaia-line bg-white py-2.5 pl-9 pr-3 text-sm text-esaia-ink placeholder:text-esaia-subtle focus:border-esaia-blue focus:outline-none" />
        </div>
      </div>

      <div className="mt-5 flex flex-wrap gap-2">
        {["", "Attention required", "Developing", "Established"].map(b => <button key={b || "all"} onClick={() => {
        setBand(b);
        setPage(1);
      }} data-testid={`eri-filter-${b ? b.toLowerCase().replace(/\s+/g, "-") : "all"}`} className={`border px-3.5 py-1.5 font-mono text-[10px] uppercase tracking-[0.15em] transition-colors ${band === b ? "border-esaia-blue bg-esaia-blue text-white" : "border-esaia-line bg-white text-esaia-muted hover:text-esaia-ink"}`}>
            {tr(b || "All")}
          </button>)}
      </div>

      <div className="mt-6">
        {!data ? <p className="text-sm text-esaia-subtle">{tr("Loading...")}</p> : data.items.length === 0 ? <EmptyState message={tr("No ERI submissions yet.")} /> : <div className="overflow-x-auto border border-esaia-line bg-white">
            <table className="w-full min-w-[760px]" data-testid="eri-table">
              <thead>
                <tr className="border-b border-esaia-line bg-esaia-surface text-left">
                  {["Name", "Company", "Email", "Date", "Score", "Readiness", "Client"].map(h => <th key={h} className="px-5 py-3 font-mono text-[10px] uppercase tracking-[0.18em] text-esaia-subtle">{tr(h)}</th>)}
                </tr>
              </thead>
              <tbody>
                {data.items.map(s => <tr key={s.id} className="border-b border-esaia-line transition-colors last:border-0 hover:bg-esaia-canvas">
                    <td className="px-5 py-3.5 text-sm">
                      <Link to={`/${lang}/admin/eri/${s.id}`} className="font-semibold text-esaia-ink hover:text-esaia-blue" data-testid={`eri-row-${s.id}`}>
                        {`${s.first_name || ""} ${s.last_name || ""}`.trim() || "—"}
                      </Link>
                    </td>
                    <td className="px-5 py-3.5 text-sm text-esaia-muted">{s.company || "—"}</td>
                    <td className="px-5 py-3.5 text-sm text-esaia-muted">{s.email || "—"}</td>
                    <td className="px-5 py-3.5 font-mono text-[11px] text-esaia-subtle">{fmtDateTime(s.created_at)}</td>
                    <td className="px-5 py-3.5 font-mono text-sm font-semibold text-esaia-ink">{s.total_score}/100</td>
                    <td className="px-5 py-3.5"><Badge tone={bandTone(s.band)}>{tr(s.band || "—")}</Badge></td>
                    <td className="px-5 py-3.5">
                      {s.client_id ? <Badge tone="blue">{tr("Linked")}</Badge> : <Badge tone="slate">{tr("Not linked")}</Badge>}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>}
      </div>

      {data && data.pages > 1 && <div className="mt-5 flex items-center gap-3">
          <button disabled={page <= 1} onClick={() => {
        setPage(page - 1);
        load(page - 1);
      }} className="border border-esaia-line bg-white px-4 py-2 text-xs font-semibold text-esaia-muted disabled:opacity-40" data-testid="eri-prev-page">{tr("Previous")}</button>
          <span className="font-mono text-[11px] text-esaia-subtle">{tr("Page")}{" "}{data.page}{" "}{tr("of")}{" "}{data.pages}</span>
          <button disabled={page >= data.pages} onClick={() => {
        setPage(page + 1);
        load(page + 1);
      }} className="border border-esaia-line bg-white px-4 py-2 text-xs font-semibold text-esaia-muted disabled:opacity-40" data-testid="eri-next-page">{tr("Next")}</button>
        </div>}
    </div>;
}
